"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.foldMapTree = foldMapTree;
exports.leaf = leaf;
exports.mapTree = mapTree;
exports.pathEqual = pathEqual;
exports.pathFromPathString = pathFromPathString;
exports.strictZipWith = strictZipWith;

var _set = require("./utils/set");

var _invariant = _interopRequireDefault(require("./utils/invariant"));

var _array = require("./utils/array");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function leaf(data) {
  return {
    type: "leaf",
    data: data
  };
}

function directionEqual(a, b) {
  if (a.type === "object" && b.type === "object") {
    return a.key === b.key;
  }

  if (a.type === "array" && b.type === "array") {
    return a.index === b.index;
  }

  return false;
}

function pathEqual(a, b) {
  return (0, _array.zip)(a, b).every(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        l = _ref2[0],
        r = _ref2[1];

    return directionEqual(l, r);
  });
}

function pathFromPathString(pathString) {
  if (pathString[0] !== "/") {
    throw new Error("Error paths must start with forward-slash");
  }

  if (pathString === "/") {
    return [];
  }

  return pathString.slice(1).split("/").map(function (keyPart) {
    // This might be dangerous, since it means you can't use numbers as object
    // keys. This is acceptable for now.
    if (!isNaN(keyPart)) {
      return {
        type: "array",
        index: Number.parseInt(keyPart, 10)
      };
    } else {
      return {
        type: "object",
        key: keyPart
      };
    }
  });
}

function strictZipWith(f, left, right) {
  if (left.type === "object" && right.type === "object") {
    if (!(0, _set.setEq)(new Set(Object.keys(left)), new Set(Object.keys(right)))) {
      throw new Error("Tried to zip two object nodes with different keys");
    }

    return {
      type: "object",
      data: f(left.data, right.data),
      children: Object.keys(left.children).reduce(function (memo, k) {
        (0, _invariant["default"])(left.type === "object" && right.type === "object", "This should never happen.");
        return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, k, strictZipWith(f, left.children[k], right.children[k])));
      }, {})
    };
  }

  if (left.type === "array" && right.type === "array") {
    if (left.children.length !== right.children.length) {
      throw new Error("Tried to zip two array nodes with different lengths");
    }

    return {
      type: "array",
      data: f(left.data, right.data),
      children: left.children.map(function (_, i) {
        (0, _invariant["default"])(left.type === "array" && right.type === "array");
        return strictZipWith(f, left.children[i], right.children[i]);
      })
    };
  }

  if (left.type === "leaf" && right.type === "leaf") {
    return {
      type: "leaf",
      data: f(left.data, right.data)
    };
  }

  throw new Error("Tried to zip two nodes of different type");
} // A tree is a functor


function mapTree(f, tree) {
  if (tree.type === "object") {
    return {
      type: "object",
      data: f(tree.data),
      children: Object.keys(tree.children).reduce(function (memo, key) {
        return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, key, mapTree(f, tree.children[key])));
      }, {})
    };
  } else if (tree.type === "array") {
    return {
      type: "array",
      data: f(tree.data),
      children: tree.children.map(function (child) {
        return mapTree(f, child);
      })
    };
  } else {
    return {
      type: "leaf",
      data: f(tree.data)
    };
  }
} // Fold a tree preorder


function foldMapTree(mapper, mempty, mappend, tree) {
  if (tree.type === "leaf") {
    return mapper(tree.data);
  } else if (tree.type === "array") {
    var foldedChildren = tree.children.reduce(function (memo, childTree) {
      return mappend(memo, foldMapTree(mapper, mempty, mappend, childTree));
    }, mempty);
    return mappend(mapper(tree.data), foldedChildren);
  } else {
    var _foldedChildren = Object.keys(tree.children).reduce(function (memo, key) {
      return mappend(memo, foldMapTree(mapper, mempty, mappend, tree.children[key]));
    }, mempty);

    return mappend(mapper(tree.data), _foldedChildren);
  }
}